export const formatTimeDifference = (
  startTime: string | number,
  endTime: string | number,
): string => {
  const startMs =
    typeof startTime === 'string' ? new Date(startTime).getTime() : startTime
  const endMs =
    typeof endTime === 'string' ? new Date(endTime).getTime() : endTime
  const diffMs = Math.abs(endMs - startMs)

  const diffDays = Math.floor(diffMs / 86400000)
  const diffHours = Math.floor((diffMs % 86400000) / 3600000)
  const diffMinutes = Math.floor((diffMs % 3600000) / 60000)
  const diffSeconds = Math.floor((diffMs % 60000) / 1000)

  const parts: string[] = []
  if (diffDays > 0) parts.push(`${diffDays}d`)
  if (diffHours > 0) parts.push(`${diffHours}h`)
  if (diffMinutes > 0) parts.push(`${diffMinutes}m`)
  if (diffSeconds > 0 || parts.length === 0) parts.push(`${diffSeconds}s`)

  return parts.join(' ')
}
